import {IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useFieldArray} from "react-hook-form";
import {RemittancesCreditFormTableRow} from "./RemittancesCreditFormTableRow";
import {Add, Delete} from "@mui/icons-material";
import {RemittancesCreditFormTableRowSum} from "./RemittancesCreditFormTableRowSum";

type RemittancesCreditFormTableProps = {
    name: string
}

export function RemittancesCreditFormTable({name}: RemittancesCreditFormTableProps) {
    const {t} = useTranslation()
    const {fields, remove, append} = useFieldArray({
        name
    })
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell/>
                        <TableCell>
                            {t('expenditure')}
                        </TableCell>
                        <TableCell>
                            {t('cashIncome')}
                        </TableCell>
                        <TableCell align={'right'}>
                            <IconButton onClick={() => {
                                append({description: ''})
                            }}>
                                <Add/>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {fields.map((field, iteration) => (
                        <TableRow key={field.id} selected={!!(iteration % 2)}>
                            <TableCell>

                                <RemittancesCreditFormTableRow
                                    name={`${name}.${iteration}`}
                                />
                            </TableCell>
                            <RemittancesCreditFormTableRowSum name={`${name}.${iteration}`}/>
                            <TableCell>
                                <IconButton
                                    onClick={() => {
                                        const confirmed = window.confirm(t('Are you sure you want to delete the row?'))
                                        if (confirmed) {
                                            remove(iteration)
                                        }
                                    }}>
                                    <Delete/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}

                </TableBody>
            </Table>
        </TableContainer>
    )
}